import React, { useContext, useEffect, useState } from 'react'
import { SchoolSummaryStyles } from './Style'
import { SmallSpace, Space } from 'styles/GlobalStyle'
import { Button, Accordion, AccordionDetails, AccordionSummary, IconButton } from '@mui/material'
import { Cancel, Delete, ExpandMore } from '@mui/icons-material'
import { isEmpty, map, pick } from 'lodash'
import { affiliationGroups, grades } from 'keys'
import { UserContext } from './UserContext'
import { roles as roleKeys } from 'keys'
import { allRoles } from 'keys/roles'

const SchoolSummary = (props) => {
    const { roleAcordions, setRoleAcordions } = useContext(UserContext)
    const { affiliation, roles, userRoleIndex, deleteClass } = props
    const [selectedClass, setSelectedClass] = useState(null)

    const isSchoolGroup = affiliation?.group_name == affiliationGroups.schools
    const learningUnitType = isSchoolGroup ? "school_class" : "learning_group"

    useEffect(() => {
        setSelectedClass(new Array(roles?.length).fill(0))
    }, [roles?.length])

    const getClasses = (test_takers) => {
        const classes = {}
        test_takers?.forEach(test_taker => {
            const { grade_name, school_class_name } = test_taker
            const classKey = `${grade_name}${school_class_name}`
            if (!classes[classKey])
                classes[classKey] = { name: classKey, value: [{ name: test_taker.test_taker_name }] }
            else classes[classKey].value.push({ name: test_taker.test_taker_name })
        })
        return map(classes)
    }

    const getData = (role) => {
        const roleName = role?.role?.name
        const roleType = allRoles[roleName]
        // כרגע רק בתפקידים בית ספריים ולא של קבוצות חיצוניות
        if (roleType == roleKeys.single) {
            let testTakers = []
            role?.data?.forEach(({ test_takers }) => {
                if (test_takers)
                    testTakers = testTakers.concat(test_takers)
            });
            return isEmpty(testTakers) ? [] : getClasses(testTakers)
        }
        else if (roleType == roleKeys.teacher) {
            if (isSchoolGroup) {
                const school_classes = {}
                role?.data?.forEach(({ grade, classes, learning_groups }) => {
                    if (grade)
                        if (!school_classes[grade?.name]) {
                            school_classes[grade.name] = {
                                name: grade.name.trim().split(' ')[1],
                                value: classes
                            }
                        }
                        else school_classes[grade?.name].value.concat(classes)
                });
                return map(school_classes)
            }
            else {
                let learningGroups = []
                role?.data?.forEach(({ learning_groups }) => {
                    learningGroups = learningGroups.concat(learning_groups)
                });
                return map(learningGroups)
            }
        }
        // כרגע רק בתפקידים בית ספריים ולא של קבוצות חיצוניות
        else if (roleType == roleKeys.coordinator) {
            return [{ value: role?.data?.[0].grades }]
        }
    }

    const selectClass = (roleIndex, index) => {
        let nSelectedClass = [...selectedClass]
        nSelectedClass[roleIndex] = index
        setSelectedClass(nSelectedClass)
    }

    const updateExpandAcordion = (roleIndex) => {
        let nRoleAcordions = { ...roleAcordions }
        nRoleAcordions[`${userRoleIndex}_${roleIndex}`] = !(nRoleAcordions[`${userRoleIndex}_${roleIndex}`])
        setRoleAcordions(nRoleAcordions)
    }

    const roleItem = {
        [`school_class_${roleKeys.teacher}`]: {
            title1: "שכבה:",
            title2: "כיתה:"
        },
        [`school_class_${roleKeys.single}`]: {
            title1: "שכבה וכיתה:",
            title2: "תלמידים:"
        },
        [`school_class_${roleKeys.coordinator}`]: {
            title2: "שכבות:"
        },
        [`learning_group_${roleKeys.coordinator}`]: {
            title1: "קבוצות:"
        },
        [`learning_group_${roleKeys.teacher}`]: {
            title1: "קבוצות:"
        },
        [`school_class_${roleKeys.single}`]: {
            title1: "קבוצה",
            title2: "תלמידים:"
        },
    }

    const title = isSchoolGroup ? "בית ספר" : "לקוח"

    return (
        <SchoolSummaryStyles>
            <div className='summary-title'>
                {"סיכום תפקידים:"}
            </div>
            <SmallSpace />
            <div className='section-title'>
                {title}
            </div>
            <div>
                {affiliation?.name}
            </div>
            <Space />
            <div className='section-title'>
                {"תפקידים:"}
            </div>
            {roles.map((role, roleIndex) => {
                const data = getData(role)
                const roleName = role?.role?.name
                const roleType = allRoles[roleName]

                return (
                    !roleType || (
                        roleType == roleKeys.principal ?
                            <div>{role.role.label}</div> :
                            <React.Fragment>
                                <SmallSpace />
                                <Accordion expanded={roleAcordions[`${userRoleIndex}_${roleIndex}`]}>
                                    <AccordionSummary
                                        expandIcon={<ExpandMore onClick={() => updateExpandAcordion(roleIndex)} />}
                                        aria-controls="panel1-content"
                                        id="panel1-header"
                                    >
                                        <div>{role.role?.label}</div>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        {roleItem[`${learningUnitType}_${roleType}`]?.title1 &&
                                            <React.Fragment>
                                                <div className='section-title'>
                                                    {roleItem[`${learningUnitType}_${roleType}`]?.title1}
                                                </div>
                                                <SmallSpace />
                                                <div className='classes-list'>
                                                    {data?.map((unit, index) =>
                                                        <Button
                                                            onClick={() => selectClass(roleIndex, index)}
                                                            variant={'contained'}
                                                            color={index == selectedClass?.[roleIndex] ? "dark" : "bg"}>
                                                            {unit?.name}
                                                        </Button>
                                                    )}
                                                </div>
                                                <Space />
                                            </React.Fragment>
                                        }


                                        <div className='section-title'>
                                            {roleItem[`${learningUnitType}_${roleType}`]?.title2}
                                        </div>
                                        <SmallSpace />
                                        <div className='test-taker-list'>
                                            {isSchoolGroup &&
                                                data?.[selectedClass?.[roleIndex]]?.value?.map((value, itemIndex) =>
                                                    <div className='value-item' key={itemIndex}>
                                                        {value?.name}
                                                        {/* <Cancel onClick={() => roleItem[roleName](userRoleIndex, roleIndex)} fontSize='small' /> */}
                                                    </div>
                                                )
                                            }
                                        </div>
                                        <SmallSpace />
                                    </AccordionDetails>
                                </Accordion>
                            </React.Fragment>
                    )
                )
            }
            )}
        </SchoolSummaryStyles>
    )

}

export default SchoolSummary